
module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ./~/vue-socket.io/~/engine.io-client/index.js
// module id = 594
// module chunks = 10